import { createSlice } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';

export interface CoreEventsSliceStates {
    event: string;
    args: any;
}

export const coreEventsSlice = createSlice({
    name: 'coreEvents',
    initialState: {
        event: '',
        args: undefined,
    },
    reducers: {
        updateEvent: (state, action) => {
            state.event = action.payload.event;
            state.args = action.payload.args;
        },
    },
});

export const coreEventReducer = coreEventsSlice.reducer;
export const coreEventAction = coreEventsSlice.actions;
export const coreEventSelector = (store: { coreEvents: CoreEventsSliceStates }) => store.coreEvents;

export const useCoreEvents = (handler?: (event: string, args: any) => void) => {
    const data = useSelector(coreEventSelector);
    const dispatch = useDispatch();

    const fire = useCallback(
        (event: string, args: any = undefined) => {
            dispatch(coreEventAction.updateEvent({ event, args: args }));
        },
        [dispatch],
    );

    const reset = useCallback(() => {
        fire('', undefined);
    }, [fire]);

    useEffect(() => {
        if (handler) {
            handler(data.event, data.args);
            reset();
        }
    }, [data, reset, handler]);

    return {
        event: data.event,
        args: data.args,
        fire,
        reset,
    };
};
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';

export interface CoreEventsSliceStates {
    event: string;
    args: any;
}

export const coreEventsSlice = createSlice({
    name: 'coreEvents',
    initialState: {
        event: '',
        args: undefined,
    },
    reducers: {
        updateEvent: (state, action) => {
            state.event = action.payload.event;
            state.args = action.payload.args;
        },
    },
});

export const coreEventReducer = coreEventsSlice.reducer;
export const coreEventAction = coreEventsSlice.actions;
export const coreEventSelector = (store: { coreEvents: CoreEventsSliceStates }) => store.coreEvents;

export const useCoreEvents = (handler?: (event: string, args: any) => void) => {
    const data = useSelector(coreEventSelector);
    const dispatch = useDispatch();

    const fire = useCallback(
        (event: string, args: any = undefined) => {
            dispatch(coreEventAction.updateEvent({ event, args: args }));
        },
        [dispatch],
    );

    const reset = useCallback(() => {
        fire('', undefined);
    }, [fire]);

    useEffect(() => {
        if (handler) {
            handler(data.event, data.args);
            reset();
        }
    }, [data, reset, handler]);

    return {
        event: data.event,
        args: data.args,
        fire,
        reset,
    };
};
